export default () => ({
  breadcrumbs: [],
  currentBreadcrumb: null
});
